(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  (() => {
    const prepareContactForm = (section) => {
      const form = section.querySelector('.main-contact__form');
      if (!form || form.dataset.contactReady === 'true') return;
      form.dataset.contactReady = 'true';
      const returnField = form.querySelector('[name="return_to"]');
      if (returnField) {
        const destination = new URL(returnField.value, window.location.origin);
        const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) destination.searchParams.set('preview_theme_id', preview);
        returnField.value = destination.pathname + destination.search + destination.hash;
      }
      const submit = form.querySelector('.main-contact__submit');
      if (submit) {
        const label = submit.textContent;
        form.addEventListener('submit', (event) => {
          if (event.defaultPrevented) return;
          submit.setAttribute('aria-busy', 'true');
          submit.textContent = submit.dataset.sendingLabel;
        });
        window.addEventListener('pageshow', () => {
          submit.removeAttribute('aria-busy');
          submit.textContent = label;
        });
      }
      const feedback = form.querySelector('[data-contact-feedback]');
      if (feedback && !window.Shopify?.designMode) {
        feedback.focus({ preventScroll: true });
        section.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    };
    document.querySelectorAll('.main-contact').forEach(prepareContactForm);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.main-contact').forEach(prepareContactForm);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  const initializePasswordSection = (root = document) => {
    root.querySelectorAll('[data-password-access]').forEach((access) => {
      if (access.querySelector('.main-password__error')) access.open = true;
    });
    root.querySelectorAll('[data-password-countdown]').forEach((countdown) => {
      if (countdown.dataset.countdownInitialized === 'true') return;
    const value = (countdown.dataset.deadline || '').trim();
    const localDate = value.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
    const deadline = localDate ? new Date(Number(localDate[3]), Number(localDate[2]) - 1, Number(localDate[1]), Number(localDate[4] || 0), Number(localDate[5] || 0), Number(localDate[6] || 0)).getTime() : Date.parse(value);
    if (!Number.isFinite(deadline)) return;
    countdown.dataset.countdownInitialized = 'true';
    const units = { days: countdown.querySelector('[data-countdown-days]'), hours: countdown.querySelector('[data-countdown-hours]'), minutes: countdown.querySelector('[data-countdown-minutes]'), seconds: countdown.querySelector('[data-countdown-seconds]') };
    const countdownUnits = countdown.querySelector('.main-password__countdown-units');
    const finished = countdown.querySelector('[data-countdown-finished]');
    const update = () => {
      const remaining = Math.max(0, deadline - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      units.days.textContent = String(days).padStart(2, '0');
      units.hours.textContent = String(hours).padStart(2, '0');
      units.minutes.textContent = String(minutes).padStart(2, '0');
      units.seconds.textContent = String(seconds).padStart(2, '0');
      countdown.hidden = false;
      if (remaining === 0) { countdownUnits.hidden = true; finished.hidden = false; return false; }
      return true;
    };
    if (update()) { const timer = window.setInterval(() => { if (!update()) window.clearInterval(timer); }, 1000); }
    });
  };

  initializePasswordSection();
  document.addEventListener('shopify:section:load', (event) => initializePasswordSection(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* V3_RESTOCK_CONTROLLER_BEGIN */
  // Klaviyo's public client endpoint. No private key, marketing opt-in or onsite SDK.
  if (!customElements.get('v3-restock-notify')) customElements.define('v3-restock-notify', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      this.trigger = this.querySelector('[data-restock-open]');
      this.form = this.querySelector('[data-restock-form]');
      this.email = this.querySelector('[data-restock-email]');
      this.submit = this.querySelector('[data-restock-submit]');
      this.status = this.querySelector('[data-restock-status]');
      this.variantLabel = this.querySelector('[data-restock-variant]');
      this.submitLabel = this.submit.textContent;
      this.variantId = '';
      this.eligible = false;
      this.configured = /^[A-Za-z0-9]{6}$/.test(this.dataset.siteId || '');
      const options = { signal: this.lifecycle.signal };
      this.trigger.addEventListener('click', () => {
        if (!this.eligible || !this.configured) return;
        this.form.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.email.focus();
      }, options);
      this.querySelector('[data-restock-close]').addEventListener('click', () => this.close(), options);
      this.form.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.close(); }
      }, options);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.subscribe(); }, options);
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.cancelRequest();
      window.clearTimeout(this.retryTimer);
    }
    cancelRequest() {
      this.request?.abort();
      this.request = null;
      window.clearTimeout(this.timeout);
      this.form?.removeAttribute('aria-busy');
      if (this.email) this.email.disabled = false;
      if (this.submit) { this.submit.disabled = false; this.submit.textContent = this.submitLabel; }
    }
    close(focus = true) {
      this.cancelRequest();
      this.form.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      if (focus && this.eligible) this.trigger.focus();
    }
    setVariant(variant) {
      const id = variant ? String(variant.id) : '';
      const eligible = this.configured && !!variant && variant.available === false && /^\d+$/.test(id);
      if (id === this.variantId && eligible === this.eligible) return;
      const hadFocus = this.contains(document.activeElement);
      this.close(false);
      this.variantId = id;
      this.eligible = eligible;
      this.hidden = !eligible;
      this.trigger.hidden = false;
      this.status.textContent = '';
      this.email.value = '';
      this.variantLabel.textContent = variant?.options?.join(' / ') || '';
      if (hadFocus && !eligible) this.closest('[data-main-product]')?.querySelector('[data-product-add]:not(:disabled)')?.focus();
    }
    async subscribe() {
      if (!this.eligible || !this.configured || this.request || this.form.hidden) return;
      if (this.retryAt > Date.now()) { this.status.textContent = this.dataset.rateError; return; }
      this.email.value = this.email.value.trim();
      if (!this.form.reportValidity()) return;
      window.clearTimeout(this.retryTimer);
      const request = new AbortController();
      this.request = request;
      this.status.textContent = '';
      this.form.setAttribute('aria-busy', 'true');
      this.submit.disabled = true;
      this.submit.textContent = this.dataset.sending;
      this.email.disabled = true;
      const payload = { data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: this.email.value } } }, channels: ['EMAIL'] }, relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.variantId}` } } } } };
      this.timeout = window.setTimeout(() => request.abort(), 15000);
      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.dataset.siteId)}`, {
          method: 'POST', mode: 'cors', credentials: 'omit', referrerPolicy: 'no-referrer',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', revision: '2026-10-15' },
          body: JSON.stringify(payload), signal: request.signal
        });
        if (this.request !== request) return;
        if (response.status === 429) {
          this.retryAt = Date.now() + 30000;
          this.status.textContent = this.dataset.rateError;
          return;
        }
        if (response.status !== 202) throw new Error('Restock request not accepted');
        this.form.hidden = true;
        this.trigger.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        this.email.value = '';
        this.status.textContent = this.dataset.success;
      } catch (error) {
        if (this.request === request) this.status.textContent = this.dataset.error;
      } finally {
        if (this.request === request) {
          this.cancelRequest();
          if (this.retryAt > Date.now()) {
            this.submit.disabled = true;
            window.clearTimeout(this.retryTimer);
            this.retryTimer = window.setTimeout(() => { this.submit.disabled = false; }, this.retryAt - Date.now());
          }
        }
      }
    }
  });
  /* V3_RESTOCK_CONTROLLER_END */
  const mainProductControllers = new Map();
  const initializeMainProducts = (container) => {
  container.querySelectorAll('[data-main-product]').forEach((productSection) => {
    if (mainProductControllers.has(productSection)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    mainProductControllers.set(productSection, controller);
    const form = productSection.querySelector('.main-product__form');
    const variantInput = productSection.querySelector('[data-product-variant-input]');
    const prices = Array.from(productSection.querySelectorAll('[data-product-price]'));
    const addButton = productSection.querySelector('[data-product-add]');
    const status = productSection.querySelector('[data-product-status]');
    const mediaScroller = productSection.querySelector('.main-product__media');
    const mediaItems = Array.from(productSection.querySelectorAll('.main-product__media-item'));
    const mediaThumbnails = Array.from(productSection.querySelectorAll('[data-product-media-thumbnail]'));
    const mediaThumbnailTrack = productSection.querySelector('.main-product__media-thumbnails');
    const mediaCounterCurrent = productSection.querySelector('[data-product-media-counter-current]');
    const previousMedia = productSection.querySelector('[data-product-media-previous]');
    const nextMedia = productSection.querySelector('[data-product-media-next]');
    const sizeGuideDialog = productSection.querySelector('[data-size-guide-dialog]');
    const sizeGuideOpen = productSection.querySelector('[data-size-guide-open]');
    const sizeGuideClose = productSection.querySelector('[data-size-guide-close]');
    const root = window.Shopify?.routes?.root || '/';
    const variantsDataElement = productSection.querySelector('[data-product-variants]');
    const optionGroups = Array.from(productSection.querySelectorAll('[data-product-option-group]'));
    let variants = [];
    let submitting = false;
    let successTimer = 0;
    let selectedImageId = null;
    signal.addEventListener('abort', () => window.clearTimeout(successTimer), { once: true });

    try {
      variants = variantsDataElement ? JSON.parse(variantsDataElement.textContent) : [];
    } catch (error) {
      console.warn('Unable to read product variants.', error);
    }

    const selectedOptions = optionGroups.map((group) => {
      const selected = group.querySelector('[data-product-option-value].is-selected');
      const select = group.querySelector('[data-product-option-select]');
      return selected?.dataset.productOptionValue || select?.value || group.querySelector('[data-product-option-value]')?.dataset.productOptionValue || '';
    });

    const findSelectedVariant = () => optionGroups.length
      ? variants.find((variant) => variant.options.every((value, index) => value === selectedOptions[index]))
      : variants.find((variant) => String(variant.id) === variantInput.value);

    const setPurchaseState = (variant) => {
      /* V3_RESTOCK_SYNC_BEGIN */
      productSection.querySelector('v3-restock-notify')?.setVariant(variant);
      /* V3_RESTOCK_SYNC_END */
      addButton.disabled = submitting || !variant?.available;
      addButton.querySelector('span').textContent = submitting ? addButton.dataset.loadingLabel
        : !variant ? addButton.dataset.unavailableLabel
        : !variant.available ? addButton.dataset.soldOutLabel : addButton.dataset.addLabel;
    };

    const showVariantImage = (variant, userChange) => {
      if (!variant?.imageId || String(variant.imageId) === selectedImageId) return;
      const item = mediaItems.find((media) => media.dataset.productImageId === String(variant.imageId));
      if (!item) return;
      selectedImageId = String(variant.imageId);
      const behavior = userChange && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto';
      if (productSection.classList.contains('main-product--media-horizontal') || window.matchMedia('(max-width: 749px)').matches) {
        mediaScroller.scrollTo({ left: item.offsetLeft, behavior });
      } else if (userChange) {
        item.scrollIntoView({ behavior, block: 'center' });
      }
    };

    const updateVariantState = (userChange = false) => {
      const variant = findSelectedVariant();
      optionGroups.forEach((group, optionIndex) => {
        const combinationsFor = (value) => variants.filter((candidate) => candidate.options[optionIndex] === value
          && selectedOptions.slice(0, optionIndex).every((previous, index) => candidate.options[index] === previous));
        const selectedLabel = group.querySelector('[data-product-selected-option]');
        if (selectedLabel) selectedLabel.textContent = selectedOptions[optionIndex];
        const select = group.querySelector('[data-product-option-select]');
        if (select) {
          select.value = selectedOptions[optionIndex];
          Array.from(select.options).forEach((option) => {
            option.disabled = submitting || !combinationsFor(option.value).length;
          });
          return;
        }
        group.querySelectorAll('[data-product-option-value]').forEach((option) => {
          const selected = option.dataset.productOptionValue === selectedOptions[optionIndex];
          const combinations = combinationsFor(option.dataset.productOptionValue);
          const hasAvailableCombination = combinations.some((candidate) => candidate.available);
          option.classList.toggle('is-selected', selected);
          option.setAttribute('aria-pressed', String(selected));
          option.classList.toggle('is-sold-out', combinations.length > 0 && !hasAvailableCombination);
          option.disabled = submitting || !combinations.length;
        });
      });

      if (!variant) {
        variantInput.value = '';
        setPurchaseState(null);
        prices.forEach((price) => {
          const currentPrice = price.querySelector('[data-product-current-price]');
          const comparePrice = price.querySelector('[data-product-compare-price]');
          if (currentPrice) currentPrice.textContent = '';
          if (comparePrice) comparePrice.hidden = true;
          price.classList.remove('main-product__price--sale');
        });
        return;
      }

      variantInput.value = variant.id;
      setPurchaseState(variant);
      prices.forEach((price) => {
        const currentPrice = price.querySelector('[data-product-current-price]');
        const comparePrice = price.querySelector('[data-product-compare-price]');
        if (currentPrice) currentPrice.textContent = variant.price;
        if (comparePrice) {
          comparePrice.hidden = !variant.onSale;
          comparePrice.textContent = variant.onSale ? variant.comparePrice : '';
        }
        price.classList.toggle('main-product__price--sale', variant.onSale);
      });
      showVariantImage(variant, userChange);
      if (userChange) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url);
      }
    };

    const selectOption = (optionIndex, value) => {
      if (submitting) return;
      selectedOptions[optionIndex] = value;
      if (!findSelectedVariant()) {
        const candidates = variants.filter((variant) => selectedOptions.slice(0, optionIndex + 1)
          .every((selected, index) => variant.options[index] === selected));
        const replacement = candidates.find((variant) => variant.available) || candidates[0];
        replacement?.options.forEach((selected, index) => { selectedOptions[index] = selected; });
      }
      window.clearTimeout(successTimer);
      status.textContent = '';
      updateVariantState(true);
    };

    if (sizeGuideDialog && sizeGuideOpen && sizeGuideClose) {
      sizeGuideOpen.addEventListener('click', () => sizeGuideDialog.showModal());
      sizeGuideClose.addEventListener('click', () => sizeGuideDialog.close());
      sizeGuideDialog.addEventListener('click', (event) => {
        if (event.target === sizeGuideDialog) sizeGuideDialog.close();
      });
    }

    if (mediaScroller) {
      const isHorizontalMedia = () => productSection.classList.contains('main-product--media-horizontal') || window.matchMedia('(max-width: 749px)').matches;
      let activeMediaIndex = 0;
      let previousMediaIndex = -1;
      const mediaScrollBehavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      const updateMediaState = () => {
        activeMediaIndex = 0;
        let closestOffset = Infinity;
        mediaItems.forEach((item, index) => {
          const offset = isHorizontalMedia()
            ? Math.abs(item.offsetLeft - mediaScroller.scrollLeft)
            : Math.abs((item.getBoundingClientRect().top + item.getBoundingClientRect().height / 2) - window.innerHeight / 2);
          if (offset < closestOffset) {
            closestOffset = offset;
            activeMediaIndex = index;
          }
        });
        mediaThumbnails.forEach((thumbnail, index) => thumbnail.setAttribute('aria-pressed', String(index === activeMediaIndex)));
        if (activeMediaIndex !== previousMediaIndex && mediaThumbnailTrack?.clientWidth) {
          const thumbnail = mediaThumbnails[activeMediaIndex];
          const trackBounds = mediaThumbnailTrack.getBoundingClientRect();
          const thumbnailBounds = thumbnail?.getBoundingClientRect();
          if (thumbnailBounds) {
            const verticalTrack = !isHorizontalMedia();
            const start = verticalTrack ? thumbnailBounds.top - trackBounds.top : thumbnailBounds.left - trackBounds.left;
            const end = verticalTrack ? thumbnailBounds.bottom - trackBounds.top : thumbnailBounds.right - trackBounds.left;
            const size = verticalTrack ? mediaThumbnailTrack.clientHeight : mediaThumbnailTrack.clientWidth;
            const offset = start < 4 ? start - 4 : end > size - 4 ? end - size + 4 : 0;
            if (offset) mediaThumbnailTrack.scrollTo({
              [verticalTrack ? 'top' : 'left']: (verticalTrack ? mediaThumbnailTrack.scrollTop : mediaThumbnailTrack.scrollLeft) + offset,
              behavior: mediaScrollBehavior()
            });
          }
        }
        previousMediaIndex = activeMediaIndex;
        if (mediaCounterCurrent) mediaCounterCurrent.textContent = String(activeMediaIndex + 1).padStart(2, '0');
        if (previousMedia && nextMedia) {
          /* The side gallery is circular: its controls stay available at both
             ends and simply wrap to the opposing image. */
          previousMedia.disabled = false;
          nextMedia.disabled = false;
        }
      };
      mediaThumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          if (isHorizontalMedia()) {
            mediaScroller.scrollTo({ left: mediaItems[index]?.offsetLeft || 0, behavior: mediaScrollBehavior() });
          } else {
            mediaItems[index]?.scrollIntoView({ behavior: mediaScrollBehavior(), block: 'center' });
          }
        }, { signal });
      });
      if (previousMedia && nextMedia) {
        const scrollToMedia = (index) => {
          mediaScroller.scrollTo({ left: mediaItems[index]?.offsetLeft || 0, behavior: mediaScrollBehavior() });
        };
        previousMedia.addEventListener('click', () => {
          scrollToMedia(activeMediaIndex === 0 ? mediaItems.length - 1 : activeMediaIndex - 1);
        });
        nextMedia.addEventListener('click', () => {
          scrollToMedia(activeMediaIndex === mediaItems.length - 1 ? 0 : activeMediaIndex + 1);
        });
      }
      mediaScroller.addEventListener('scroll', updateMediaState, { passive: true });
      window.addEventListener('scroll', updateMediaState, { passive: true, signal });
      window.addEventListener('resize', updateMediaState, { signal });
      updateMediaState();
    }

    if (mediaScroller) {
      let mouseDragStartX = 0;
      let mouseDragStartScroll = 0;
      let isMouseDragging = false;
      let mousePointerId = null;

      mediaScroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        mousePointerId = event.pointerId;
        isMouseDragging = false;
        mouseDragStartX = event.clientX;
        mouseDragStartScroll = mediaScroller.scrollLeft;
      });

      mediaScroller.addEventListener('pointermove', (event) => {
        if (event.pointerId !== mousePointerId) return;
        if (!isMouseDragging && Math.abs(event.clientX - mouseDragStartX) > 8) {
          isMouseDragging = true;
          mediaScroller.setPointerCapture(event.pointerId);
          mediaScroller.classList.add('is-dragging');
        }
        if (!isMouseDragging) return;
        event.preventDefault();
        mediaScroller.scrollLeft = mouseDragStartScroll - (event.clientX - mouseDragStartX);
      });

      const endMouseDrag = (event) => {
        mousePointerId = null;
        isMouseDragging = false;
        mediaScroller.classList.remove('is-dragging');
        if (mediaScroller.hasPointerCapture(event.pointerId)) mediaScroller.releasePointerCapture(event.pointerId);
      };

      mediaScroller.addEventListener('pointerup', endMouseDrag);
      mediaScroller.addEventListener('pointercancel', endMouseDrag);
    }

    if (optionGroups.length && variants.length) {
      optionGroups.forEach((group, optionIndex) => {
        const select = group.querySelector('[data-product-option-select]');
        select?.addEventListener('change', () => {
          selectOption(optionIndex, select.value);
        });
        group.querySelectorAll('[data-product-option-value]').forEach((option) => {
          option.addEventListener('click', () => {
            if (option.disabled) return;
            selectOption(optionIndex, option.dataset.productOptionValue);
          });
        });
      });
      updateVariantState();
    }
    if (!optionGroups.length && variants.length) updateVariantState();

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting || addButton.disabled || !findSelectedVariant()?.available) return;
      window.clearTimeout(successTimer);
      submitting = true;
      form.setAttribute('aria-busy', 'true');
      addButton.setAttribute('aria-busy', 'true');
      updateVariantState();
      status.textContent = '';
      try {
        const fields = new FormData(form);
        const properties = {};
        for (const [name, value] of fields.entries()) {
          const property = name.match(/^properties\[(.+)\]$/);
          if (property && typeof value === 'string') properties[property[1]] = value;
        }
        const payload = { id: Number(variantInput.value), quantity: 1, properties };
        if (fields.get('selling_plan')) payload.selling_plan = fields.get('selling_plan');
        const response = await fetch(`${root}cart/add.js`, {
          body: JSON.stringify(payload),
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          method: 'POST', signal
        });
        const result = await response.json();
        if (!response.ok) {
          const failure = new Error();
          failure.userMessage = typeof result.description === 'string' ? result.description : addButton.dataset.errorLabel;
          throw failure;
        }
        if (signal.aborted) return;
        submitting = false;
        updateVariantState();
        addButton.querySelector('span').textContent = addButton.dataset.addedLabel;
        status.textContent = addButton.dataset.addedLabel;
        window.dispatchEvent(new CustomEvent('minimal:cart-updated', { detail: { added: true, trigger: addButton } }));
        successTimer = window.setTimeout(() => setPurchaseState(findSelectedVariant()), 1400);
      } catch (error) {
        if (signal.aborted) return;
        status.textContent = error.userMessage || addButton.dataset.errorLabel;
        submitting = false;
        updateVariantState();
      } finally {
        form.removeAttribute('aria-busy');
        addButton.removeAttribute('aria-busy');
      }
    });
  });
  };
  initializeMainProducts(document);
  document.addEventListener('shopify:section:load', (event) => initializeMainProducts(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    mainProductControllers.forEach((controller, productSection) => {
      if (!event.target.contains(productSection)) return;
      controller.abort();
      mainProductControllers.delete(productSection);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-campaign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let editorStartVisible = true;
    const isThemeEditor = Boolean(window.Shopify?.designMode);
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    const motionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
    const getCampaignVideo = (campaign) => {
      if (mobileMedia.matches) {
        const mobileVideo = campaign.querySelector('.minimal-campaign__video--mobile');
        if (mobileVideo) return mobileVideo;
        if (campaign.hasAttribute('data-campaign-mobile-image')) return null;
      }
      return campaign.querySelector('.minimal-campaign__video--desktop');
    };
    const canPlayCampaignVideo = (campaign) => {
      return !motionMedia.matches && !document.hidden && !campaign.classList.contains('is-dismissed')
        && (!isThemeEditor || editorStartVisible);
    };
    const syncCampaignVideo = (campaign) => {
      const activeVideo = getCampaignVideo(campaign);
      campaign.querySelectorAll('.minimal-campaign__video').forEach((video) => {
        if (video !== activeVideo || !canPlayCampaignVideo(campaign) || video.error) {
          video.pause();
          video.classList.remove('minimal-campaign__video--visible');
        } else if (video.paused) {
          video.play().catch(() => video.classList.remove('minimal-campaign__video--visible'));
        }
      });
    };
    const syncEditorPreview = (resetScroll = false) => {
      if (!isThemeEditor) return;
      document.querySelectorAll('.minimal-campaign--editor').forEach((campaign) => {
        campaign.classList.toggle('is-dismissed', !editorStartVisible);
        campaign.closest('.shopify-section')?.classList.toggle('minimal-campaign-section--editor-hidden', !editorStartVisible);
        syncCampaignVideo(campaign);
      });
      if (resetScroll) {
        document.querySelector('#MainContent')?.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }
      window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    };
    const selectEditorSection = (event) => {
      if (!isThemeEditor) return;
      const section = event.target.closest('.shopify-section');
      if (!section) return;
      const showStart = Boolean(section.querySelector('.minimal-campaign--editor'));
      const changed = showStart !== editorStartVisible;
      editorStartVisible = showStart;
      syncEditorPreview(changed);
    };
    const initialize = (root) => {
      root.querySelectorAll('[data-campaign-entry]').forEach((campaign) => {
        if (campaign.dataset.initialized) return;
        campaign.dataset.initialized = 'true';
        if (!isThemeEditor && document.documentElement.classList.contains('minimal-catalog-entry')) campaign.classList.add('is-dismissed');
        campaign.querySelectorAll('.minimal-campaign__video').forEach((video) => {
          video.muted = true;
          video.addEventListener('playing', () => {
            if (video === getCampaignVideo(campaign) && canPlayCampaignVideo(campaign)) video.classList.add('minimal-campaign__video--visible');
            else syncCampaignVideo(campaign);
          });
          const showVideoFallback = () => {
            video.classList.remove('minimal-campaign__video--visible');
          };
          video.addEventListener('error', showVideoFallback);
          const sources = video.querySelectorAll('source');
          const failedSources = new Set();
          sources.forEach((source) => source.addEventListener('error', () => {
            failedSources.add(source);
            if (failedSources.size === sources.length) showVideoFallback();
          }));
        });
        syncCampaignVideo(campaign);
        campaign.querySelectorAll('[data-campaign-link]').forEach((link) => {
          const target = new URL(link.href, window.location.origin);
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview && target.origin === window.location.origin) {
            target.searchParams.set('preview_theme_id', preview);
            link.href = target.href;
          }
          link.addEventListener('click', (event) => {
            if (window.Shopify?.designMode || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self') || target.origin !== window.location.origin || (target.pathname === window.location.pathname && target.search === window.location.search) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
            event.preventDefault();
            if (document.documentElement.classList.contains('minimal-entry-leaving')) return;
            try { window.sessionStorage.setItem('minimal-page-enter', JSON.stringify({ pathname: target.pathname, expires: Date.now() + 15000 })); } catch {}
            document.documentElement.classList.add('minimal-entry-leaving');
            window.setTimeout(() => window.location.assign(link.href), 200);
          });
        });
      });
    };
    initialize(document);
    syncEditorPreview();
    const syncAllCampaignVideos = () => {
      document.querySelectorAll('[data-campaign-entry]').forEach(syncCampaignVideo);
    };
    window.addEventListener('resize', syncAllCampaignVideos);
    mobileMedia.addEventListener('change', syncAllCampaignVideos);
    motionMedia.addEventListener('change', syncAllCampaignVideos);
    document.addEventListener('visibilitychange', syncAllCampaignVideos);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
      syncEditorPreview();
    });
    document.addEventListener('shopify:section:select', selectEditorSection);
    document.addEventListener('shopify:block:select', selectEditorSection);
    document.addEventListener('shopify:section:reorder', () => syncEditorPreview());
    document.addEventListener('shopify:section:unload', () => {
      window.requestAnimationFrame(() => syncEditorPreview());
    });
    window.addEventListener('pageshow', () => document.documentElement.classList.remove('minimal-entry-leaving'));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-cart-drawer"]) return;
  try {
    
  document.querySelectorAll('[data-cart-drawer]').forEach((drawer) => {
    const content = drawer.querySelector('[data-cart-content]');
    const recommendations = JSON.parse(drawer.querySelector('[data-cart-recommendations]')?.textContent || '[]');
    const root = window.Shopify?.routes?.root || '/';
    const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      currency: currency || 'USD',
      currencyDisplay: 'symbol',
      style: 'currency'
    }).format(amount / 100);
    const decodeHtml = (value) => {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = String(value || '');
      return textarea.value;
    };
    const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
    })[character]);
    const shippingGoal = Math.max(0, Number(drawer.dataset.freeShippingGoal || 0)) * 100;
    let latestCart;
    let lastTrigger;
    let recommendationsCollapsed = false;

    const recommendationMarkup = (cart) => {
      const cartProductIds = new Set(cart.items.map((item) => item.product_id));
      const available = recommendations.filter((product) => product.available && !cartProductIds.has(product.id)).slice(0, 5);
      if (!available.length) return '';

      return `
        <section class="minimal-cart-drawer__recommendations${recommendationsCollapsed ? ' is-collapsed' : ''}">
          <button class="minimal-cart-drawer__recommendations-title" type="button" data-recommendations-toggle aria-expanded="${String(!recommendationsCollapsed)}">${escapeHtml(drawer.dataset.recommendationsLabel)}</button>
          <div class="minimal-cart-drawer__recommendations-grid">
            ${available.map((product) => `
              <article>
                <a class="minimal-cart-drawer__recommendation-image" href="${escapeHtml(product.url)}">
                  ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
                </a>
                <a class="minimal-cart-drawer__recommendation-title" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
                <span class="minimal-cart-drawer__recommendation-price">${money(product.price, cart.currency)}</span>
                ${product.hasSingleVariant ? `<button class="minimal-cart-drawer__recommendation-action" type="button" data-recommendation-add="${product.variantId}">${escapeHtml(drawer.dataset.addLabel)}</button>` : `<a class="minimal-cart-drawer__recommendation-action" href="${escapeHtml(product.url)}">${escapeHtml(drawer.dataset.viewLabel)}</a>`}
              </article>
            `).join('')}
          </div>
        </section>
      `;
    };

    const itemMarkup = (item, cart) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="minimal-cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>` : '';
      const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
      const removeLabel = drawer.dataset.removeLabel.replace('__product__', item.product_title);
      return `
        <article class="minimal-cart-drawer__item">
          <a class="minimal-cart-drawer__image" href="${escapeHtml(item.url)}">${image}</a>
          <div>
            <a class="minimal-cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${variant}
            <p class="minimal-cart-drawer__item-price">${money(item.final_line_price, cart.currency)}</p>
          </div>
          <div class="minimal-cart-drawer__quantity">
            <button class="minimal-cart-drawer__quantity-button" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="${escapeHtml(drawer.dataset.decreaseLabel)}">−</button>
            <span>${item.quantity}</span>
            <button class="minimal-cart-drawer__quantity-button" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="${escapeHtml(drawer.dataset.increaseLabel)}">+</button>
            <button class="minimal-cart-drawer__remove" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="0" aria-label="${escapeHtml(removeLabel)}">×</button>
          </div>
        </article>
      `;
    };

    const render = (cart) => {
      latestCart = cart;
      if (!cart.item_count) {
        content.innerHTML = `<p class="minimal-cart-drawer__empty">${escapeHtml(drawer.dataset.emptyLabel)}</p><a class="minimal-cart-drawer__continue" href="${escapeHtml(root)}">${escapeHtml(drawer.dataset.continueLabel)}</a>`;
        return;
      }

      const remaining = Math.max(0, shippingGoal - cart.total_price);
      const progress = shippingGoal ? Math.min(100, (cart.total_price / shippingGoal) * 100) : 0;
      const shipping = shippingGoal ? (remaining ? decodeHtml(drawer.dataset.awayLabel).replace('__amount__', money(remaining, cart.currency)) : decodeHtml(drawer.dataset.freeShippingLabel)) : '';
      content.innerHTML = `
        ${shippingGoal ? `<p class="minimal-cart-drawer__shipping">${escapeHtml(shipping)}</p><div class="minimal-cart-drawer__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}"><span class="minimal-cart-drawer__progress-fill" style="width:${progress}%"></span></div>` : ''}
        <div class="minimal-cart-drawer__items">${cart.items.map((item) => itemMarkup(item, cart)).join('')}</div>
        ${recommendationMarkup(cart)}

        <div
          class="custom-cart-promo"
          role="status"
          style="border: 1px solid currentColor; padding: 12px 16px; text-align: center; text-transform: uppercase; font-size: 13px; letter-spacing: 0.04em; margin-top: 24px; margin-bottom: 24px;"
        >
          ${cart.item_count === 1
            ? 'Додайте ще 2 товара, щоб отримати один бескоштовно '
            : cart.item_count === 2
              ? 'Додайте ще 1 товар, щоб отримати один бескоштовно '
              : 'Умови акції виконані: один товар у подарунок!! 🖤'
          }
        </div>

        <div class="minimal-cart-drawer__footer">
          <span class="minimal-cart-drawer__total-label">${escapeHtml(drawer.dataset.totalLabel)}</span>
          <span class="minimal-cart-drawer__total-price">${money(cart.total_price, cart.currency)}</span>
          <a class="minimal-cart-drawer__checkout" href="${root}checkout">${escapeHtml(drawer.dataset.checkoutLabel)}</a>
        </div>
      `;
    };

    const getCart = async () => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load cart');
      const cart = await response.json();
      render(cart);
      return cart;
    };

    let closeTimer;

    const close = () => {
      window.clearTimeout(closeTimer);
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      lastTrigger?.focus();
      closeTimer = window.setTimeout(() => { drawer.hidden = true; }, 540);
    };

    const open = async (trigger) => {
      window.clearTimeout(closeTimer);
      lastTrigger = trigger || document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      void drawer.offsetWidth;
      window.requestAnimationFrame(() => drawer.classList.add('is-open'));
      drawer.querySelector('[data-cart-close]')?.focus();
      try { await getCart(); } catch (error) { content.innerHTML = `<p class="minimal-cart-drawer__empty">${escapeHtml(drawer.dataset.emptyLabel)}</p>`; }
    };

    drawer.querySelectorAll('[data-cart-close]').forEach((control) => control.addEventListener('click', close));
    document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => trigger.addEventListener('click', (event) => { event.preventDefault(); open(trigger); }));
    window.addEventListener('minimal:cart-open', () => open());
    window.addEventListener('minimal:cart-updated', () => { if (!drawer.hidden) getCart(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !drawer.hidden) close(); });

    content.addEventListener('click', async (event) => {
      const recommendationsToggle = event.target.closest('[data-recommendations-toggle]');
      if (recommendationsToggle) {
        const section = recommendationsToggle.closest('.minimal-cart-drawer__recommendations');
        recommendationsCollapsed = section.classList.toggle('is-collapsed');
        recommendationsToggle.setAttribute('aria-expanded', String(!recommendationsCollapsed));
        return;
      }

      const change = event.target.closest('[data-cart-change]');
      const add = event.target.closest('[data-recommendation-add]');
      if (!change && !add) return;
      event.preventDefault();
      try {
        if (change) {
          await fetch(`${root}cart/change.js`, {
            body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity) }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });
        }
        if (add) {
          await fetch(`${root}cart/add.js`, {
            body: JSON.stringify({ id: Number(add.dataset.recommendationAdd), quantity: 1 }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });
        }
        await getCart();
        window.dispatchEvent(new Event('minimal:cart-updated'));
      } catch (error) {
        if (latestCart) render(latestCart);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-cookie-banner"]) return;
  try {
    
  document.querySelectorAll('[data-cookie-banner]').forEach((banner) => {
    const manageButton = banner.querySelector('[data-cookie-manage]');
    const acceptButton = banner.querySelector('[data-cookie-accept]');
    const declineButton = banner.querySelector('[data-cookie-decline]');
    const saveButton = banner.querySelector('[data-cookie-save]');
    const preferences = banner.querySelector('[data-cookie-preferences]');
    const preferenceInput = banner.querySelector('[data-cookie-preferences-input]');
    const analyticsInput = banner.querySelector('[data-cookie-analytics-input]');
    const marketingInput = banner.querySelector('[data-cookie-marketing-input]');

    const announceState = () => {
      document.dispatchEvent(new CustomEvent('minimal:cookie-banner-state', {
        detail: { visible: !banner.hidden }
      }));
    };
    const hideBanner = () => {
      banner.hidden = true;
      announceState();
    };
    const hasAnswer = (value) => value === 'yes' || value === 'no';

    const captureConsent = (consent) => {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy?.setTrackingConsent) return;
      privacy.setTrackingConsent(consent, hideBanner);
    };

    const showWhenNeeded = () => {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy) return;

      const visitorConsent = privacy.currentVisitorConsent?.() || {};
      const hasRecordedChoice = [visitorConsent.preferences, visitorConsent.analytics, visitorConsent.marketing].some(hasAnswer);
      const requiredByRegion = privacy.shouldShowBanner?.() === true;

      banner.hidden = !(requiredByRegion || !hasRecordedChoice);
      announceState();
    };

    const initialisePrivacyApi = () => {
      if (window.Shopify?.customerPrivacy) {
        showWhenNeeded();
        return;
      }

      if (!window.Shopify?.loadFeatures) {
        announceState();
        return;
      }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) {
          showWhenNeeded();
        } else {
          announceState();
        }
      });
    };

    manageButton?.addEventListener('click', () => {
      const current = window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || {};
      preferenceInput.checked = current.preferences === 'yes';
      analyticsInput.checked = current.analytics === 'yes';
      marketingInput.checked = current.marketing === 'yes';
      preferences.hidden = false;
      manageButton.hidden = true;
    });

    acceptButton?.addEventListener('click', () => captureConsent({ preferences: true, analytics: true, marketing: true }));
    declineButton?.addEventListener('click', () => captureConsent({ preferences: false, analytics: false, marketing: false }));
    saveButton?.addEventListener('click', () => captureConsent({
      preferences: preferenceInput.checked,
      analytics: analyticsInput.checked,
      marketing: marketingInput.checked
    }));

    initialisePrivacyApi();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-header"]) return;
  try {
    
  const initializeMinimalMobileNavigation = (scope = document) => {
    scope.querySelectorAll('.minimal-header').forEach((header) => {
      if (header.minimalMobileNavigationCleanup) {
        header.minimalMobileNavigationUpdate();
        return;
      }
      const navigation = header.querySelector('.minimal-header__collections');
      const list = header.querySelector('.minimal-header__collection-list');
      const brand = header.querySelector('.minimal-header__brand');
      const controls = header.querySelector('.minimal-header__side--end');
      const toggle = header.querySelector('[data-navigation-toggle]');
      const state = header.querySelector('.minimal-header__collections-state');
      const actions = header.querySelector('[data-mobile-menu-actions]');
      if (!navigation || !list || !brand || !controls || !toggle || !state) return;
      const media = window.matchMedia('(max-width: 749px)');
      const abort = new AbortController();
      const signal = abort.signal;
      const moved = [
        ['[data-customer-account]', () => actions],
        ['.minimal-header__game', () => actions],
        ['[data-theme-toggle]', () => actions],
        ['[data-layout-toggle]', () => document.querySelector('[data-mobile-catalog-tools]')],
        ['[data-catalog-return]', () => document.querySelector('[data-mobile-product-tools]')]
      ].map(([selector, target]) => {
        const element = header.querySelector(selector);
        if (!element) return null;
        const siblings = Array.from(element.parentNode.childNodes);
        return { element, target, parent: element.parentNode, following: siblings.slice(siblings.indexOf(element) + 1) };
      }).filter(Boolean);
      let frame = 0;
      const isDisclosure = () => media.matches || header.classList.contains('minimal-header--compact-navigation');
      const syncMenu = () => {
        toggle.setAttribute('aria-expanded', String(state.checked));
        list.inert = isDisclosure() && !state.checked;
      };
      const close = (restoreFocus = false) => {
        state.checked = false;
        syncMenu();
        if (restoreFocus) toggle.focus({ preventScroll: true });
      };
      const restore = (record) => {
        if (record.element.parentNode === record.parent) return;
        record.parent.insertBefore(record.element, record.following.find((node) => node.parentNode === record.parent) || null);
      };
      const setPixels = (name, value) => {
        const pixels = `${Math.max(0, Math.floor(value))}px`;
        if (header.style.getPropertyValue(name) !== pixels) header.style.setProperty(name, pixels);
      };
      const update = () => {
        frame = 0;
        if (!header.isConnected) return;
        moved.forEach((record) => {
          const target = media.matches ? record.target() : null;
          if (target) {
            if (record.element.parentNode !== target) target.append(record.element);
          } else {
            restore(record);
          }
        });
        syncMenu();
        if (!media.matches) {
          ['--minimal-header-mobile-navigation-width', '--minimal-header-mobile-logo-max-width', '--minimal-header-mobile-menu-height'].forEach((name) => header.style.removeProperty(name));
          return;
        }
        const bounds = header.getBoundingClientRect();
        const center = bounds.left + bounds.width / 2;
        const controlBounds = Array.from(controls.children, (element) => element.getBoundingClientRect()).filter((rect) => rect.width > 0);
        const controlsLeft = Math.min(bounds.right - 16, ...controlBounds.map((rect) => rect.left));
        const toggleRight = toggle.getBoundingClientRect().right;
        setPixels('--minimal-header-mobile-logo-max-width', Math.min(center - toggleRight - 12, controlsLeft - center - 12) * 2);
        setPixels('--minimal-header-mobile-menu-height', list.offsetHeight || 0);
      };
      const schedule = () => { if (!frame) frame = window.requestAnimationFrame(update); };
      toggle.addEventListener('click', () => {
        state.checked = !state.checked;
        syncMenu();
        schedule();
      }, { signal });
      state.addEventListener('change', syncMenu, { signal });
      document.addEventListener('pointerdown', (event) => {
        if (state.checked && !navigation.contains(event.target)) close();
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !state.checked) return;
        event.preventDefault();
        close(true);
      }, { signal });
      document.addEventListener('focusin', (event) => {
        if (state.checked && !navigation.contains(event.target)) close();
      }, { signal });
      list.addEventListener('click', (event) => {
        if (event.target.closest('[data-box-game-open]')) close(true);
        else if (event.target.closest('a')) close();
      }, { signal });
      const observer = new ResizeObserver(schedule);
      [header, brand, controls, list].filter(Boolean).forEach((element) => observer.observe(element));
      window.addEventListener('resize', schedule, { passive: true, signal });
      window.addEventListener('pageshow', () => { close(); schedule(); }, { signal });
      window.addEventListener('minimal-layout-state', schedule, { signal });
      document.addEventListener('minimal:catalog-ready', schedule, { signal });
      media.addEventListener('change', () => { close(); schedule(); }, { signal });
      header.minimalMobileNavigationUpdate = schedule;
      header.minimalMobileNavigationCleanup = () => {
        abort.abort();
        observer.disconnect();
        window.cancelAnimationFrame(frame);
        moved.forEach(restore);
        list.inert = false;
        delete header.minimalMobileNavigationCleanup;
        delete header.minimalMobileNavigationUpdate;
      };
      update();
    });
  };
  initializeMinimalMobileNavigation();
  document.addEventListener('shopify:section:load', () => initializeMinimalMobileNavigation());
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('.minimal-header').forEach((header) => header.minimalMobileNavigationCleanup?.()));

  const preserveMinimalHeaderPreview = (scope = document) => {
    const currentTheme = window.Shopify?.theme;
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id')
      || (['unpublished', 'development'].includes(currentTheme?.role) && currentTheme.id ? String(currentTheme.id) : '');
    if (!preview) return;
    scope.querySelectorAll('.minimal-header a[href]').forEach((link) => {
      if (link.hasAttribute('data-customer-account')) return;
      const target = new URL(link.href, window.location.origin);
      if (target.origin !== window.location.origin) return;
      target.searchParams.set('preview_theme_id', preview);
      link.href = target.href;
    });
  };
  preserveMinimalHeaderPreview();
  document.addEventListener('shopify:section:load', (event) => preserveMinimalHeaderPreview(event.target));


  /* The theme editor preserves native checkbox state while it applies a
     setting change. A mobile menu that happened to be open must not survive
     a logo-position change and leave a detached second navigation row. */
  const closeMinimalHeaderCollections = (scope = document) => {
    scope.querySelectorAll('.minimal-header__collections-state').forEach((control) => {
      control.checked = false;
      control.dispatchEvent(new Event('change'));
    });
  };

  document.addEventListener('shopify:section:load', (event) => {
    closeMinimalHeaderCollections(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    closeMinimalHeaderCollections(event.target);
  });

  const initializeMinimalHeaderScroll = (scope = document) => {
    scope.querySelectorAll('.minimal-header').forEach((header) => {
      if (header.minimalHeaderScrollCleanup) {
        header.minimalHeaderScrollUpdate();
        return;
      }
      const abort = new AbortController();
      const signal = abort.signal;
      const catalogScroller = document.querySelector('#MainContent');
      const announcement = header.parentElement?.querySelector('.minimal-announcement');
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!header.isConnected) return;
        const mainScrolls = catalogScroller && ['auto', 'scroll'].includes(window.getComputedStyle(catalogScroller).overflowY);
        const isHomeHeader = header.hasAttribute('data-v3-home-header');
        const banner = isHomeHeader ? document.querySelector('v3-home-banner') : null;
        let scrollTop = Math.max(0, mainScrolls ? catalogScroller.scrollTop : window.scrollY);
        if (isHomeHeader) {
          const scroller = mainScrolls ? catalogScroller : document.scrollingElement || document.documentElement;
          const maximum = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
          scrollTop = Math.min(scrollTop, maximum);
        }
        const bannerBounds = banner?.getBoundingClientRect();
        const overBanner = Boolean(bannerBounds && bannerBounds.height > 0 && bannerBounds.bottom > Math.max(0, header.getBoundingClientRect().bottom));
        const scrolled = isHomeHeader ? !overBanner : scrollTop > 12;
        header.classList.toggle('is-v3-banner-active', overBanner);
        header.classList.toggle('is-scrolled', scrolled);
        announcement?.classList.toggle('is-scrolled', banner ? scrollTop > 12 : scrolled);
      };
      const schedule = () => {
        if (!frame) frame = window.requestAnimationFrame(update);
      };
      const resize = new ResizeObserver(schedule);
      resize.observe(header);
      const banner = header.hasAttribute('data-v3-home-header') ? document.querySelector('v3-home-banner') : null;
      if (banner) resize.observe(banner);
      window.addEventListener('scroll', schedule, { passive: true, signal });
      catalogScroller?.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      window.addEventListener('pageshow', schedule, { signal });
      document.addEventListener('minimal:catalog-ready', schedule, { signal });
      document.addEventListener('shopify:section:load', schedule, { signal });
      document.addEventListener('shopify:section:unload', schedule, { signal });
      window.addEventListener('minimal-layout-state', () => {
        header.classList.toggle('is-stage-active', Boolean(document.querySelector('.product-carousel')));
        schedule();
      }, { signal });
      header.minimalHeaderScrollUpdate = schedule;
      header.minimalHeaderScrollCleanup = () => {
        abort.abort();
        resize.disconnect();
        window.cancelAnimationFrame(frame);
        delete header.minimalHeaderScrollUpdate;
        delete header.minimalHeaderScrollCleanup;
      };
      update();
    });
  };
  initializeMinimalHeaderScroll();
  document.addEventListener('shopify:section:load', (event) => initializeMinimalHeaderScroll(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('.minimal-header').forEach((header) => header.minimalHeaderScrollCleanup?.()));

  document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
    const root = document.documentElement;
    const storageKey = 'minimal-collections-theme-override-v2';
    const themeMode = button.dataset.themeMode || 'light';
    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)');
    let savedTheme = null;

    try {
      if (!window.Shopify?.designMode) savedTheme = window.localStorage.getItem(storageKey);
    } catch (error) {
      savedTheme = null;
    }

    const setTheme = (isDark) => {
      root.classList.toggle('theme-dark', isDark);
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', isDark ? button.dataset.lightLabel : button.dataset.darkLabel);
      const mobileLabel = button.querySelector('[data-mobile-theme-label]');
      if (mobileLabel) mobileLabel.textContent = button.getAttribute('aria-label');
    };

    const resolveTheme = () => {
      if (savedTheme === 'dark') return true;
      if (savedTheme === 'light') return false;
      if (themeMode === 'dark') return true;
      if (themeMode === 'light') return false;
      return themeMode === 'auto' && systemTheme.matches;
    };

    setTheme(resolveTheme());

    systemTheme.addEventListener('change', () => {
      if (savedTheme == null && themeMode === 'auto') setTheme(systemTheme.matches);
    });

    button.addEventListener('click', () => {
      const isDark = !root.classList.contains('theme-dark');
      setTheme(isDark);

      try {
        window.localStorage.setItem(storageKey, isDark ? 'dark' : 'light');
        savedTheme = isDark ? 'dark' : 'light';
      } catch (error) {
        return;
      }
    });
  });

  const updateCartCount = async () => {
    const triggers = Array.from(document.querySelectorAll('[data-cart-trigger]'));
    if (!triggers.length) return;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();

      triggers.forEach((trigger) => {
        const count = trigger.querySelector('[data-cart-count]');
        if (count) {
          count.textContent = cart.item_count;
        }
        trigger.setAttribute('aria-label', cart.item_count ? `${trigger.dataset.cartLabel}: ${cart.item_count}` : trigger.dataset.cartLabel);
        trigger.classList.toggle('is-cart-active', cart.item_count > 0);
      });
    } catch (error) {
      return;
    }
  };

  window.addEventListener('minimal:cart-updated', updateCartCount);

  document.querySelectorAll('[data-layout-toggle]').forEach((button) => {
    const syncLayoutToggle = ({ available, single }) => {
      /* In the editor, the carousel deliberately renders as a stable static
         grid so Shopify can safely replace the section after a setting
         change. Keep the mobile switch available there: it only changes the
         local 1/2-card preview and does not ask Shopify to re-render. */
      button.hidden = !available;
      button.dataset.layoutMode = single ? 'single' : 'grid';
      button.setAttribute('aria-label', single ? button.dataset.gridLabel : button.dataset.singleLabel);
    };

    window.addEventListener('minimal-layout-state', (event) => syncLayoutToggle(event.detail));
    if (window.minimalCatalogLayoutState) syncLayoutToggle(window.minimalCatalogLayoutState);

    /* This listener belongs to the actual header button rather than to a
       shared window handler. It therefore survives any live re-render of the
       carousel section and always dispatches to the current carousel node. */
    if (button.dataset.layoutToggleBound !== 'true' && !button.hasAttribute('onclick')) {
      button.dataset.layoutToggleBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const carousel = document.querySelector('.product-carousel');
        if (!carousel) return;

        /* Shopify can replace the carousel markup after any editor setting
           update without replaying that section's JavaScript. A static grid
           still only needs its CSS variables changed, so make the mobile
           1↔2 preview toggle work directly from the persistent header. */
        if (window.innerWidth < 750 && carousel.classList.contains('product-carousel--static-grid')) {
          const currentColumns = Number(carousel.style.getPropertyValue('--product-carousel-mobile-columns')) || 1;
          const nextColumns = currentColumns === 1 ? 2 : 1;
          carousel.style.setProperty('--product-carousel-mobile-columns', String(nextColumns));
          carousel.style.setProperty('--product-carousel-mobile-media-height', nextColumns === 2 ? '42vw' : '76vw');
          button.dataset.layoutMode = nextColumns === 1 ? 'single' : 'grid';
          button.setAttribute('aria-label', nextColumns === 1 ? button.dataset.gridLabel : button.dataset.singleLabel);
          window.minimalCatalogLayoutState = { available: true, single: nextColumns === 1 };
          return;
        }

        if (carousel.classList.contains('product-carousel--static-grid') && window.Shopify?.designMode) {
          const showingSinglePreview = carousel.classList.toggle('product-carousel--editor-single-preview');
          button.dataset.layoutMode = showingSinglePreview ? 'single' : 'grid';
          button.setAttribute('aria-label', showingSinglePreview ? button.dataset.gridLabel : button.dataset.singleLabel);
          window.minimalCatalogLayoutState = { available: true, single: showingSinglePreview };
          return;
        }

        carousel.dispatchEvent(new CustomEvent('minimal-layout-toggle'));
      });
    }
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();
    const initialize = (section) => {
      if (cleanups.has(section)) return;
      const controller = new AbortController();
      const observers = [];
      const frames = new Set();
      const options = { signal: controller.signal };
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview) section.querySelectorAll('a[href]').forEach((link) => {
        const target = new URL(link.href, window.location.origin);
        if (target.origin !== window.location.origin) return;
        target.searchParams.set('preview_theme_id', preview);
        link.href = target.href;
      });
      section.querySelectorAll('[data-related-gallery]').forEach((gallery) => {
        const track = gallery.querySelector('[data-related-media-track]');
        const slides = Array.from(gallery.querySelectorAll('[data-related-media-slide]'));
        const dots = Array.from(gallery.querySelectorAll('[data-related-media-dot]'));
        if (!track || !slides.length) return;
        let activeIndex = 0;
        let scrollFrame = 0;
        let pointerId = null;
        let startX = 0;
        let startY = 0;
        let startScroll = 0;
        let dragging = false;
        let suppressClick = false;
        const syncState = () => {
          let dotIndex = -1;
          dots.forEach((dot, index) => {
            if (activeIndex >= Number(dot.dataset.relatedMediaDot)) dotIndex = index;
          });
          dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === dotIndex);
            dot.setAttribute('aria-current', String(index === dotIndex));
          });
          slides.forEach((slide, index) => {
            const active = index === activeIndex;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
            slide.tabIndex = active ? 0 : -1;
          });
        };
        const showImage = (index, behavior = 'smooth') => {
          if (!track.clientWidth) return;
          const target = Math.max(0, Math.min(index, slides.length - 1));
          track.scrollTo({
            left: slides[target].offsetLeft,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : behavior
          });
        };
        track.addEventListener('scroll', () => {
          if (scrollFrame) return;
          scrollFrame = window.requestAnimationFrame(() => {
            frames.delete(scrollFrame);
            scrollFrame = 0;
            let nearest = 0;
            slides.forEach((slide, index) => {
              if (Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[nearest].offsetLeft - track.scrollLeft)) nearest = index;
            });
            activeIndex = nearest;
            syncState();
          });
          frames.add(scrollFrame);
        }, { ...options, passive: true });
        dots.forEach((dot) => dot.addEventListener('click', () => showImage(Number(dot.dataset.relatedMediaDot)), options));
        track.addEventListener('pointerdown', (event) => {
          suppressClick = false;
          if (event.pointerType !== 'mouse' || event.button !== 0 || slides.length < 2) return;
          pointerId = event.pointerId;
          startX = event.clientX;
          startY = event.clientY;
          startScroll = track.scrollLeft;
          dragging = false;
        }, options);
        track.addEventListener('pointermove', (event) => {
          if (event.pointerId !== pointerId) return;
          const distance = event.clientX - startX;
          if (!dragging && Math.abs(distance) > 8 && Math.abs(distance) > Math.abs(event.clientY - startY)) {
            dragging = true;
            suppressClick = true;
            track.style.scrollSnapType = 'none';
            track.setPointerCapture?.(event.pointerId);
          }
          if (!dragging) return;
          event.preventDefault();
          track.scrollLeft = startScroll - distance;
        }, options);
        const finishDrag = (event) => {
          if (event.pointerId !== pointerId) return;
          pointerId = null;
          const dragged = dragging;
          dragging = false;
          if (track.hasPointerCapture?.(event.pointerId)) track.releasePointerCapture(event.pointerId);
          track.style.removeProperty('scroll-snap-type');
          if (!dragged) return;
          const distance = event.clientX - startX;
          const startIndex = Math.round(startScroll / track.clientWidth);
          const target = Math.abs(distance) > Math.min(48, track.clientWidth * .18)
            ? startIndex + (distance < 0 ? 1 : -1) : startIndex;
          showImage(target);
        };
        track.addEventListener('pointerup', finishDrag, options);
        track.addEventListener('pointercancel', (event) => {
          if (event.pointerId !== pointerId) return;
          pointerId = null;
          dragging = false;
          track.style.removeProperty('scroll-snap-type');
          showImage(activeIndex);
        }, options);
        track.addEventListener('dragstart', (event) => event.preventDefault(), options);
        track.addEventListener('touchstart', (event) => {
          suppressClick = false;
          startX = event.touches[0]?.clientX || 0;
          startY = event.touches[0]?.clientY || 0;
        }, { ...options, passive: true });
        track.addEventListener('touchend', (event) => {
          const touch = event.changedTouches[0];
          if (touch && (Math.abs(touch.clientX - startX) > 8 || Math.abs(touch.clientY - startY) > 8)) suppressClick = true;
        }, { ...options, passive: true });
        gallery.addEventListener('click', (event) => {
          if (!suppressClick) return;
          suppressClick = false;
          event.preventDefault();
          event.stopPropagation();
        }, options);
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(() => showImage(activeIndex, 'instant'));
          observer.observe(track);
          observers.push(observer);
        }
        syncState();
      });
      cleanups.set(section, () => {
        controller.abort();
        observers.forEach((observer) => observer.disconnect());
        frames.forEach((frame) => window.cancelAnimationFrame(frame));
        cleanups.delete(section);
      });
    };
    const initializeWithin = (root) => root.querySelectorAll('.minimal-related-products').forEach(initialize);
    initializeWithin(document);
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.minimal-related-products').forEach((section) => cleanups.get(section)?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-splash-page"]) return;
  try {
    
  document.querySelectorAll('[data-splash-page]').forEach((splash) => {
    const time = splash.querySelector('[data-splash-time]');
    if (!time) return;

    const updateTime = () => {
      const now = new Date();
      const date = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(now);
      const clock = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        hour: 'numeric',
        minute: '2-digit'
      }).format(now);
      time.textContent = `${date}  ·  ${clock}`;
    };

    updateTime();
    window.setInterval(updateTime, 1000);
  });

  document.querySelectorAll('.minimal-splash-page--link-animation-highlight').forEach((splash) => {
    const usesTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    if (!usesTouch) return;

    const links = splash.querySelectorAll('.minimal-splash-page__links a');
    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        if (link.classList.contains('is-touch-highlighted')) return;

        event.preventDefault();
        links.forEach((otherLink) => otherLink.classList.remove('is-touch-highlighted'));
        link.classList.add('is-touch-highlighted');
      });
    });
  });

  document.querySelectorAll('[data-splash-theme-toggle]').forEach((button) => {
    const root = document.documentElement;
    const storageKey = 'minimal-collections-theme-override-v2';

    const updateButton = () => {
      const isDark = root.classList.contains('theme-dark');
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', isDark ? button.dataset.lightLabel : button.dataset.darkLabel);
    };

    updateButton();
    button.addEventListener('click', () => {
      const isDark = !root.classList.contains('theme-dark');
      root.classList.toggle('theme-dark', isDark);
      try {
        window.localStorage.setItem(storageKey, isDark ? 'dark' : 'light');
      } catch (error) {
        /* The visual toggle still works if storage is unavailable. */
      }
      updateButton();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v3-featured-products')) {
    customElements.define('v3-featured-products', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.querySelectorAll('.v3-products__card').forEach(card => {
          const images = Array.from(card.querySelectorAll('[data-v3-card-image]'));
          const dots = Array.from(card.querySelectorAll('[data-v3-card-dot]'));
          if (images.length < 2 || !dots.length) return;
          const show = target => {
            if (!Number.isInteger(target) || target < 0 || target >= images.length) return;
            images.forEach((image, index) => { image.hidden = index !== target; });
            dots.forEach(dot => {
              const active = Number(dot.dataset.v3CardDot) === target;
              dot.classList.toggle('is-active', active);
              dot.setAttribute('aria-current', String(active));
            });
          };
          dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.v3CardDot)), { signal }));
        });
        const track = this.querySelector('.v3-products__track');
        if (!track || !this.classList.contains('v3-products--horizontal')) return;
        let pointer = null;
        let dragged = false;
        let suppressClick = false;
        let startX = 0;
        let startY = 0;
        let startScroll = 0;
        const step = () => { const cards = track.querySelectorAll('.v3-products__card'); return cards.length > 1 ? Math.abs(cards[1].offsetLeft - cards[0].offsetLeft) : track.clientWidth; };
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(track).direction === 'rtl';
          const left = event.key === 'Home' ? 0 : event.key === 'End' ? track.scrollWidth * (rtl ? -1 : 1) : track.scrollLeft + step() * (event.key === 'ArrowRight' ? 1 : -1);
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
        track.addEventListener('pointerdown', event => {
          suppressClick = false;
          if (event.target?.closest('button')) return;
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          pointer = event.pointerId; dragged = false; startX = event.clientX; startY = event.clientY; startScroll = track.scrollLeft;
        }, { signal });
        track.addEventListener('pointermove', event => {
          if (event.pointerId !== pointer) return;
          const distance = event.clientX - startX;
          if (!dragged && Math.abs(distance) > 8 && Math.abs(distance) > Math.abs(event.clientY - startY)) {
            dragged = true; suppressClick = true; track.style.scrollSnapType = 'none'; track.setPointerCapture?.(pointer); this.classList.add('is-dragging');
          }
          if (dragged) { event.preventDefault(); track.scrollLeft = startScroll - distance; }
        }, { signal });
        const release = event => {
          if (event.pointerId !== pointer) return;
          if (track.hasPointerCapture?.(pointer)) track.releasePointerCapture(pointer);
          pointer = null; track.style.removeProperty('scroll-snap-type'); this.classList.remove('is-dragging');
          if (dragged) track.scrollTo({ left: Math.round(track.scrollLeft / Math.max(1, step())) * step(), behavior: 'instant' });
          dragged = false;
        };
        window.addEventListener('pointerup', release, { signal });
        window.addEventListener('pointercancel', release, { signal });
        track.addEventListener('click', event => { if (suppressClick) { suppressClick = false; event.preventDefault(); event.stopImmediatePropagation(); } }, { capture: true, signal });
      }
      disconnectedCallback() { this.abort?.abort(); this.querySelector('.v3-products__track')?.style.removeProperty('scroll-snap-type'); this.classList.remove('is-dragging'); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-home-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v3-home-banner')) {
    customElements.define('v3-home-banner', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.nativeMotion = window.CSS?.supports('animation-timeline: view()') && window.CSS?.supports('animation-range: exit 0% exit 100%');
        this.frame = 0;
        const queue = () => { if (!this.frame) this.frame = requestAnimationFrame(() => this.update()); };
        const options = { passive: true, signal: this.abort.signal };
        if (!this.nativeMotion) window.addEventListener('scroll', queue, options);
        window.addEventListener('resize', queue, options);
        window.addEventListener('pageshow', queue, options);
        this.motion.addEventListener('change', queue, { signal: this.abort.signal });
        this.resize = new ResizeObserver(queue);
        this.resize.observe(this);
        this.setupVideo();
        this.update();
      }
      setupVideo() {
        this.videoHost = this.querySelector('[data-banner-video-host]');
        this.playback = this.querySelector('[data-banner-playback]');
        if (!this.videoHost || !this.playback) return;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.userPaused = false;
        this.manualPlay = false;
        this.inView = this.getBoundingClientRect().bottom > 0 && this.getBoundingClientRect().top < window.innerHeight;
        const options = { signal: this.abort.signal };
        this.mobile.addEventListener('change', () => this.selectVideo(), options);
        this.motion.addEventListener('change', () => { this.manualPlay = false; this.syncVideo(); }, options);
        document.addEventListener('visibilitychange', () => this.syncVideo(), options);
        this.playback.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          this.manualPlay = !this.userPaused;
          this.syncVideo();
        }, options);
        this.videoObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncVideo();
        });
        this.videoObserver.observe(this);
        this.selectVideo();
      }
      selectVideo() {
        const template = this.querySelector(`[data-banner-video="${this.mobile.matches ? 'mobile' : 'desktop'}"]`);
        if (!template || this.videoId === template.dataset.videoId) return;
        this.releaseVideo();
        this.videoId = template.dataset.videoId;
        const video = template.content.firstElementChild.cloneNode(true);
        this.video = video;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.tabIndex = -1;
        this.videoAbort = new AbortController();
        const paint = () => this.paintPlayback();
        for (const event of ['playing', 'pause', 'error']) video.addEventListener(event, paint, { signal: this.videoAbort.signal });
        this.videoHost.replaceChildren(video);
        this.playback.hidden = false;
        this.paintPlayback();
        this.syncVideo();
      }
      syncVideo() {
        const video = this.video;
        if (!video) return;
        const shouldPlay = this.inView && !document.hidden && !this.userPaused && (!this.motion.matches || this.manualPlay);
        if (!shouldPlay) {
          this.playAttempt = null;
          video.pause();
          this.paintPlayback();
          return;
        }
        if (!video.paused || this.playAttempt === video) return;
        this.playAttempt = video;
        const attempt = video.play();
        if (attempt) attempt.catch(() => {}).finally(() => {
          if (this.video !== video) return;
          this.playAttempt = null;
          this.paintPlayback();
        });
        else this.playAttempt = null;
      }
      paintPlayback() {
        if (!this.video || !this.playback) return;
        const label = this.video.paused ? this.playback.dataset.play : this.playback.dataset.pause;
        this.playback.textContent = label;
        this.playback.setAttribute('aria-label', label);
      }
      releaseVideo() {
        this.videoAbort?.abort();
        if (this.video) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          this.video.load();
          this.video.remove();
        }
        this.video = null;
        this.videoId = null;
        this.playAttempt = null;
      }
      update() {
        this.frame = 0;
        if (this.nativeMotion || this.dataset.reveal !== 'true' || this.dataset.editor === 'true' || window.Shopify?.designMode || this.motion.matches) {
          this.style.removeProperty('--v3-banner-shift');
          return;
        }
        const bounds = this.getBoundingClientRect();
        const shift = Math.min(bounds.height, Math.max(0, -bounds.top)) * .18;
        this.style.setProperty('--v3-banner-shift', `${Math.round(shift * 100) / 100}px`);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.videoObserver?.disconnect();
        this.releaseVideo();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-main-search"]) return;
  try {
    
  const preserveSearchPreview = () => {
    const id = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (!id) return;
    document.querySelectorAll('.v3-main-search').forEach(section => {
      const form = section.querySelector('form');
      if (!form.querySelector('[name="preview_theme_id"]')) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = id; form.append(input);
      }
      section.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('preview_theme_id', id);
        link.href = url.href;
      });
    });
  };
  preserveSearchPreview();
  document.addEventListener('shopify:section:load', preserveSearchPreview);

  } catch(e) { console.error(e); }
})();
})();
